import { useQuery } from "@apollo/client/react";
import useChatDocuments from "@repo/components/src/hooks/agent/useChatDocuments";
import { useMemo } from "react";

export type PostTypeInfo = {
  platformName: string;
  postTypeName: string;
};

/**
 * `postTypeId` -> `{platformName, postTypeName}`, for the "Instagram · Reel"
 * title on each deliverable card. The draft only ever stores the id (the same
 * shape the wizard's own `content` schema writes), so this is the same
 * "one batch query rather than N" pattern `ProductsSection` uses for products —
 * except here the list is small and effectively static, so it is fetched
 * unfiltered rather than by id.
 */
export const usePostTypeLookup = (): Map<string, PostTypeInfo> => {
  const documents = useChatDocuments();
  const { data } = useQuery(documents.postTypes);
  return useMemo(() => {
    const postTypes = data?.generic.postTypes ?? [];
    return new Map(
      postTypes.map((postType) => [
        postType.id,
        {
          platformName: postType.platform?.name ?? "",
          postTypeName: postType.name,
        },
      ]),
    );
  }, [data]);
};
